"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _immutabilityHelper = _interopRequireDefault(require("immutability-helper"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Button = require("../../elements/button/Button");
var _FormErrorSummaryLink = _interopRequireDefault(require("../form-error-summary-link/FormErrorSummaryLink"));
var _FormField = _interopRequireDefault(require("../form-field/FormField"));
var _Message = require("../message/Message");
var _FormModule = _interopRequireDefault(require("./Form.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["onChange"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Form = /*#__PURE__*/function (_Component) {
  function Form() {
    var _this;
    _classCallCheck(this, Form);
    _this = _callSuper(this, Form);
    // stores the fields' validation configuration outside of state
    _defineProperty(_this, "validationConfig", {});
    _this.state = {
      fields: {},
      submitting: false,
      showErrorMessage: false,
      submitted: false
    };
    _this.onFieldChange = _this.onFieldChange.bind(_this);
    _this.onSubmit = _this.onSubmit.bind(_this);
    return _this;
  }
  _inherits(Form, _Component);
  return _createClass(Form, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var fields = {};
      this.props.fields.forEach(function (field) {
        // initialise the field state
        fields[field.id] = {
          name: field.name,
          value: _this2.props.initialValues[field.name] || '',
          error: _this2.props.fieldErrors[field.id] || ''
        };
        var validationMessageKeys = field.validationMessageKeys,
          maxLength = field.maxLength,
          regex = field.regex,
          required = field.required;

        // initialise the field validation
        _this2.validationConfig[field.id] = {
          validationMessageKeys: validationMessageKeys,
          maxLength: maxLength,
          regex: regex,
          required: required
        };
      });
      this.setState({
        fields: fields
      });
    }
  }, {
    key: "validateRegex",
    value: function validateRegex(id, regex, value) {
      var errorMessage = '';
      var validationMessageKeys = this.validationConfig[id].validationMessageKeys;
      // Single regex
      if (regex instanceof RegExp) {
        if (!value.match(regex)) {
          errorMessage = validationMessageKeys.regex;
        }
        // Array of regexes
      } else {
        regex.forEach(function (rgx) {
          var _rgx$message = rgx.message,
            message = _rgx$message === void 0 ? '' : _rgx$message,
            _rgx$pattern = rgx.pattern,
            pattern = _rgx$pattern === void 0 ? undefined : _rgx$pattern,
            _rgx$getStringSegment = rgx.getStringSegment,
            getStringSegment = _rgx$getStringSegment === void 0 ? undefined : _rgx$getStringSegment,
            _rgx$positiveMatch = rgx.positiveMatch,
            positiveMatch = _rgx$positiveMatch === void 0 ? true : _rgx$positiveMatch;
          if (pattern instanceof RegExp) {
            if (typeof getStringSegment === 'function') {
              var stringSegment = getStringSegment(value);
              if (typeof stringSegment === 'string') {
                var doesMatch = pattern.test(stringSegment);
                if (positiveMatch && doesMatch || !positiveMatch && !doesMatch) {
                  errorMessage = validationMessageKeys[message];
                }
              }
            } else if (!pattern.test(value) && !errorMessage) {
              errorMessage = validationMessageKeys[message];
            }
          }
        });
      }
      return errorMessage;
    }
  }, {
    key: "validate",
    value: function validate(id, value) {
      var _this$validationConfi = this.validationConfig[id],
        required = _this$validationConfi.required,
        regex = _this$validationConfi.regex,
        maxLength = _this$validationConfi.maxLength,
        validationMessageKeys = _this$validationConfi.validationMessageKeys;
      var errorMessage = '';
      if (required && value === '') {
        errorMessage = validationMessageKeys.required;
      } else if (value && maxLength && value.length > maxLength) {
        errorMessage = validationMessageKeys.maxLength;
      } else if (value && regex) {
        errorMessage = this.validateRegex(id, regex, value);
      }
      return errorMessage;
    }
  }, {
    key: "onFieldChange",
    value: function onFieldChange(id, e) {
      var value = e.target ? e.target.value : e;
      var fields = (0, _immutabilityHelper.default)(this.state.fields, _defineProperty({}, id, {
        value: {
          $set: value
        }
      }));

      // only validate on field change when form has already been submitted
      if (this.state.submitted) {
        fields[id].error = this.validate(id, value);
      }
      this.setState({
        fields: fields,
        showErrorMessage: false
      });
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(e) {
      var _this3 = this;
      e.preventDefault();
      if (typeof this.props.onPreSubmit === 'function') {
        this.props.onPreSubmit();
      }
      var fields = this.state.fields;
      var formData = {};
      var errors = {};
      var valid = true;
      Object.keys(fields).forEach(function (id) {
        var field = fields[id];
        field.error = _this3.validate(id, field.value);

        // use name rather than id because the form uses the name to identify the field
        formData[field.name] = field.value;
        if (field.error) {
          errors[field.name] = field.error;
          valid = false;
        }
      });
      this.setState({
        fields: fields,
        submitted: true,
        showErrorMessage: !valid
      });
      if (valid) {
        if (typeof this.props.onSubmit === 'function') {
          this.setState({
            submitting: true
          });
          this.props.onSubmit(formData, function () {
            _this3.setState({
              submitting: false
            });
          });
        }
      } else if (typeof this.props.onError === 'function') {
        this.props.onError(errors);
      }
    }
  }, {
    key: "getErrorTitle",
    value: function getErrorTitle(errors) {
      var _this$props = this.props,
        showNetworkError = _this$props.showNetworkError,
        serverError = _this$props.serverError;
      if (showNetworkError) {
        return "We're sorry, but something's not working right now";
      } else if (serverError && serverError.title) {
        return serverError.title;
      }
      return errors === 1 ? 'There is 1 error below. Please correct it and try again.' : "There are ".concat(errors, " errors below. Please correct them and try again.");
    }
  }, {
    key: "getErrorBody",
    value: function getErrorBody(errors) {
      var _this$props2 = this.props,
        showNetworkError = _this$props2.showNetworkError,
        serverError = _this$props2.serverError,
        hideFirstErrorLink = _this$props2.hideFirstErrorLink;
      if (showNetworkError) {
        return 'Please try again later';
      } else if (serverError && serverError.body) {
        return serverError.body;
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormErrorSummaryLink.default, {
        hideFirstErrorLink: hideFirstErrorLink,
        totalValidationErrors: errors
      });
    }
  }, {
    key: "countErrors",
    value: function countErrors() {
      var _this4 = this;
      var errors = 0;

      // TODO find a better way of doing this
      Object.keys(this.state.fields).forEach(function (id) {
        var field = _this4.state.fields[id];
        if (field.error) {
          errors += 1;
        }
      });
      return errors;
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      var errors = this.countErrors();
      var _this$props3 = this.props,
        showNetworkError = _this$props3.showNetworkError,
        serverError = _this$props3.serverError,
        fields = _this$props3.fields,
        formId = _this$props3.formId,
        submitButton = _this$props3.submitButton,
        hasCancelButton = _this$props3.hasCancelButton,
        action = _this$props3.action,
        method = _this$props3.method,
        scrollValidationMessageIntoView = _this$props3.scrollValidationMessageIntoView;
      var submitFailed = this.state.showErrorMessage && errors > 0 || showNetworkError || serverError;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
        action: action,
        className: _FormModule.default['c-form'],
        "data-jlds": true,
        method: method,
        noValidate: true,
        onSubmit: this.onSubmit,
        children: [submitFailed && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: _FormModule.default['c-form__error'],
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Message.Message, {
            body: this.getErrorBody(errors),
            className: _FormModule.default.message,
            dataId: "".concat(formId, "-error-message"),
            dataTestId: "".concat(formId, "-error-message"),
            scrollToMessageOnMount: scrollValidationMessageIntoView,
            title: this.getErrorTitle(errors),
            type: "error"
          })
        }), fields.map(function (field) {
          var fieldState = _this5.state.fields[field.id] || {};
          var _onChange = field.onChange,
            allOtherProps = _objectWithoutProperties(field, _excluded);
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormField.default, _objectSpread(_objectSpread({
            formId: formId,
            input: {
              value: fieldState.value,
              onBlur: function onBlur() {},
              onFocus: function onFocus() {},
              name: field.id,
              onChange: function onChange(e) {
                _this5.onFieldChange(field.id, e);
                if (_onChange) {
                  _onChange(e);
                }
              }
            },
            meta: {
              error: fieldState.error,
              submitFailed: submitFailed
            }
          }, allOtherProps), {}, {
            element: field.component,
            highlightError: !!fieldState.error
          }), field.id);
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: _FormModule.default['c-form__submit'],
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.PrimaryButton, {
            submitting: this.state.submitting,
            type: "submit",
            children: submitButton
          }), hasCancelButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.SecondaryButton, {
            onClick: this.props.onCancel,
            type: "button",
            children: "Cancel"
          })]
        })]
      });
    }
  }]);
}(_react.Component);
Form.propTypes = {
  /** The html form action to be performed if js isn't running (yet) */
  action: _propTypes.default.string,
  /** The html form method if js isn't running (yet) */
  method: _propTypes.default.oneOf(['GET', 'POST']),
  /** an array of field configurations */
  fields: _propTypes.default.arrayOf(_propTypes.default.shape()),
  /** an object of field initial values */
  initialValues: _propTypes.default.objectOf(_propTypes.default.string),
  /** an object of field errors */
  fieldErrors: _propTypes.default.objectOf(_propTypes.default.string),
  /** the function called when the form submitted before data is validated */
  onPreSubmit: _propTypes.default.func,
  /** the function called when the form submitted with valid data */
  onSubmit: _propTypes.default.func,
  /** the function called when the cancel button is clicked */
  onCancel: _propTypes.default.func,
  /** the function called when the form submitted with invalid data */
  onError: _propTypes.default.func,
  /** the text shown on the submit button */
  submitButton: _propTypes.default.string,
  /** the text shown on the cancel button */
  hasCancelButton: _propTypes.default.bool,
  /** required for the FormField component */
  formId: _propTypes.default.string,
  /** Scroll form error message into view when it mounts */
  scrollValidationMessageIntoView: _propTypes.default.bool,
  /** show a predefined form-level network error */
  showNetworkError: _propTypes.default.bool,
  /** show a configurable form-level server error */
  serverError: _propTypes.default.objectOf(_propTypes.default.string),
  /** Hide the link to the first error so it only appears to keyboard/screenreader users */
  hideFirstErrorLink: _propTypes.default.bool
};
Form.defaultProps = {
  action: undefined,
  method: undefined,
  fields: [],
  initialValues: {},
  fieldErrors: {},
  onPreSubmit: function onPreSubmit() {},
  onSubmit: function onSubmit() {},
  onError: function onError() {},
  onCancel: function onCancel() {},
  submitButton: 'Submit',
  hasCancelButton: false,
  formId: "form-".concat(Date.now()),
  showNetworkError: false,
  serverError: null,
  hideFirstErrorLink: false,
  scrollValidationMessageIntoView: false
};
var _default = exports.default = Form;